export default { sha: 'a32bc84854893d7c21b266a300a54aef39e91caa', buildNumber: 'undefined' }
